import axios from 'axios';
import authHeader from "@/service/auth-header";

class CompanyService {

    async getCompanies() {
        return await axios.get(`/api/company`, {headers: authHeader()})
    }

    async getCompany(companyId) {
        console.log("[CompanyService][getCompany] Before getting company. Company ID = ", companyId);
        return await axios.get(`/api/company/specific/${companyId}`, {headers: authHeader()})
    }

    async createCompany(data) {
        console.log("[CompanyService][createCompany] Before creating company back-end API call. Data = ", data);
        return await axios.post(`/api/company`, data, {headers: authHeader()});
    }

    async updateCompany(companyId, data) {
        console.log("[CompanyService][updateCompany] Before updating company back-end API call. Data = ", data);
        return await axios.put(`/api/company/${companyId}`, data, {headers: authHeader()});
    }

    async deleteCompany(companyId) {
        console.log("[CompanyService][deleteCompany] Before deleting company. Company ID = ", companyId);
        return await axios.delete(`/api/company/${companyId}`, {headers: authHeader()});
    }

    async getCompanyConfiguration(companyId) {
        console.log("[CompanyService][getCompanyConfiguration] Before getting company configuration. Company ID = ", companyId);
        return await axios.get(`/api/companyconfig/${companyId}`, {headers: authHeader()})
    }

    async updateCompanyConfiguration(companyId, data) {
        console.log("[CompanyService][updateCompanyConfiguration] Before updating company configuration back-end API call. Data = ", data);
        return await axios.put(`/api/companyconfig/${companyId}`, data, {headers: authHeader()});
    }

    async loadDefaultUnpaidTemplates(companyId) {
        console.log("[CompanyService][loadDefaultUnpaidTemplates] Before loading default unpaid templates");
        return await axios.post(`/api/companyconfig/load/unpaidtemplates/${companyId}`, null, {headers: authHeader()});
    }

}

export default new CompanyService();
